
import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { Toast } from 'vant'
import { unbindWechat } from '@/apis/myInfo/myInfo';
import { isWechat } from '@/utils/common';
import i18n from '@/lang/index';

@Component({})
export default class MyAccountManage extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private detailInfo: any = [
    {
      text: i18n.t('ktpMy.账号'),
      info: this.userInfo.account,
      routerBind: '',
    },
    {
      text: i18n.t('ktpMy.微信'),
      info: this.userInfo.openid?(this.userInfo.wechat_nikename?this.userInfo.wechat_nikename:i18n.t('ktpMy.已绑定')):'',
      routerBind: 'wechat',
    },
    {
      text: i18n.t('ktpMy.邮箱'),
      info: this.userInfo.email,
      routerBind: 'email',
    },
    {
      text: i18n.t('ktpMy.手机号'),
      info: this.userInfo.mobile,
      routerBind: 'mobile',
    },
    {
      text: i18n.t('ktpMy.密码'),
      info: '******',
      routerBind: 'password',

    },
  ]

  bind(index: number) {
    if (this.detailInfo[index].routerBind !== '') {
      this.$router.push({ path: '/accoundNumberInfo', query: { bind: this.detailInfo[index].routerBind } })
    }
  }
  clearData() {
    localStorage.removeItem('token');
    // 注册补全流程中断可能残留旧账号的临时 token,请求拦截器会优先使用它,必须一并清掉
    localStorage.removeItem('token_for_login');
    localStorage.removeItem('code_key');
    sessionStorage.clear();
    // SPA 不刷新页面,重置内存中的旧用户信息,避免重新登录前后展示旧账号
    this.$store.commit('setUserInfo', { id: '', username: '', usertype: '0' });
    this.wsMsgModule.loginParam = undefined
    Toast.success(i18n.t('ktpMy.退出成功'))
    this.$router.push('/login')
  }
  loginOut() {
    if(isWechat){
      this.$dialog
      .confirm({
        title: i18n.t('ktpMy.确认登出此账号') as string,
        message: `${this.userInfo.openid ? i18n.t('ktpMy.退出登录将解绑当前的微信号'): ''}`
      })
      .then(() => {
        //这里是需要判断，是否是微信，如果是微信才解绑
        if(isWechat == true){
          if (this.userInfo.openid) {
            unbindWechat()
            .then(() => {
              this.clearData();
            })
            .catch((err) => {
              console.log(err)
            })
          }else{
            this.clearData();
          }
        }else{
          this.clearData();
        }
      })
      .catch(() => {
        // on cancel
      });
    }else{
      this.$dialog
      .confirm({
        title: i18n.t('ktpMy.确认登出此账号') as string,
        message: `${this.userInfo.openid ? i18n.t('ktpMy.退出登录') : ''}`
      })
      .then(() => {
        this.clearData();
      });
    }
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.账号') as string,
      showTitle: true,
      backConfig: () => {
        this.$router.push('/ktpMy')
      },
    })
  }
}
